import { Injectable, inject, OnDestroy } from '@angular/core';
import { Observable, of, Subject, takeUntil, map, catchError } from 'rxjs';
import { ServiceInvoker } from './service-invoker';
import { ResponseStatusInterface } from '../models/app.model';
import { ResponseStatus } from 'src/config/constants';
import { ContractDetailsService } from './contract-details.service';
import { logHttpError } from './http-error-logger';

@Injectable({
  providedIn: 'root'
})
export class FileMetadataService implements OnDestroy {
  private readonly dataService = inject(ServiceInvoker);
  private readonly contractDetailsService = inject(ContractDetailsService);

  private readonly unsubscribeSub: Subject<void> = new Subject<any>()
  fileMetadata: any;
  responseStatus: ResponseStatusInterface = ResponseStatus;
  filesToDownload: any = {};

  fetchFileMetadata(): Observable<any> {
    const contractNumber = this.contractDetailsService.getContractNumber();
    return this.dataService.getFileDownloadMetadata(contractNumber).pipe(
      takeUntil(this.unsubscribeSub),
      map((metadata) => {
        if (metadata.data) {
          this.setFileMetadata(metadata.data);
          return this.responseStatus.success;
        }
        logHttpError('FileMetadataService', 'getFileDownloadMetadata returned non-success response', metadata, { contractNumber });
        return metadata?.error?.errorCode === 401 ? '401' : '500';
      }),
      catchError((res) => {
        logHttpError('FileMetadataService', 'getFileDownloadMetadata request failed', res, { contractNumber });
        return of(res?.error?.errorCode === 401 ? '401' : '500');
      })
    );
  }

  getFileMetadata(): any {
    return this.fileMetadata;
  }

  setFileMetadata(metadata: any): any {
    this.fileMetadata = metadata;
  }

  getRequirementsWithDownload(): Set<any> {
    const reqs = new Set<any>();
  
    this.fileMetadata?.requirements?.forEach((req: any) => {
      if (req.files.some((file: any) => !file.downloaded)) {
        reqs.add(req.requirementId);
      }
    });
  
    return reqs;
  }

  ngOnDestroy(): void {
    this.unsubscribeSub.next();
    this.unsubscribeSub.complete();
  }
}
